import "./HomePage.css";
import React from "react";
import Equipo from "../../components/0. DashBoard/1. Equipos/Equipo";
import Asistencia from "../../components/0. DashBoard/2. Asistencias/AsistenciaModal";
import Counters from "../../components/0. DashBoard/3. Counters/Counters";
import Comentarios from "../../components/0. DashBoard/4. Comentarios/Comentarios";
import Calendario from "../../components/0. DashBoard/8. Calendario/Calendario";
import Procesos from "../../components/0. DashBoard/9. Procesos/Procesos";

const HomePage = () => {
  return (
    <>
      <Equipo />
      <Asistencia />
      <div id="Home-Upper">
        <div id="Home-Left">
          <Counters />
          <div id="Home-Left-Lower">
            <Calendario />
          </div>
        </div>
        <div id="Home-Right">
          <Comentarios />
        </div>
      </div>
      <div id="Home-Lower">
        <Procesos />
      </div>
    </>
  );
};

export default HomePage;
